import { Controller } from 'stimulus'; 
export default class extends Controller {

  static targets = [
    "actualColorRadio",
    "abbreviatedColorRadio",
    "colorSelectionDiv",
    "colorSelect",
  ];

  connect() {
    this.phoneColorTypeChange(null);
  }

  enforceCaps(event){
    const input = event.target;
    input.value = input.value.toUpperCase();
  }

  phoneColorTypeChange(event) {

    var selectHidden = null;

    if (this.actualColorRadioTarget.checked)
      selectHidden = true;
    else if (this.abbreviatedColorRadioTarget.checked)
      selectHidden = false;

    this.colorSelectionDivTarget.hidden = selectHidden;
    this.colorSelectTarget.required = !selectHidden;
  }
}

